"use client";

import React, { createContext, useContext, useState } from "react";
import {
  AuthorizedProgressContextState,
  useServiceProgressContext,
} from "@/hooks/progress-context/use-service-progress-provider";
import {
  forceCancelTts,
  getActiveTtsById,
} from "@/actions/db/text-to-speeches";

interface TextToSpeechProgressContextState
  extends AuthorizedProgressContextState {
  result: string;
}

const TextToSpeechProgressContext = createContext<
  TextToSpeechProgressContextState | undefined
>(undefined);

export const useTextToSpeechProgressContext =
  (): TextToSpeechProgressContextState => {
    const context = useContext(TextToSpeechProgressContext);
    if (!context) {
      throw new Error(
        "useTextToSpeechProgressContext must be used within an TextToSpeechProgressContext",
      );
    }
    return context;
  };

export const TextToSpeechProgressProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [result, setResult] = useState<string>("");

  const handleCompleteMessage = async (message: any) => {
    const savedSong = message.songs[""];
    setResult(savedSong);
  };

  const baseContext = useServiceProgressContext({
    forceCancelProcess: forceCancelTts,
    getActiveItemByUserId: getActiveTtsById,
    handleCompleteMessage,
    taskType: "textToSpeech",
  });

  return (
    <TextToSpeechProgressContext.Provider value={{ ...baseContext, result }}>
      {children}
    </TextToSpeechProgressContext.Provider>
  );
};
